import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { useState } from 'react'
import { PublisherRequestTypeEnum } from '@modules/api-core'
import { REQUESTS_LIST_COLUMNS_STRINGS } from './strings'

export type TPublisherRequestListReviewTypeFilter = 'approval' | 'copyright' | null

type ReviewTypeColumnHeaderProps = {
  reviewTypeFilter: TPublisherRequestListReviewTypeFilter
  onReviewTypeFilterChange: (filter: TPublisherRequestListReviewTypeFilter) => void
}

export const ReviewTypeColumnHeader = ({
  reviewTypeFilter,
  onReviewTypeFilterChange,
}: ReviewTypeColumnHeaderProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)
  const isFiltered = reviewTypeFilter !== null

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 0.5,
          width: '100%',
          pr: 0.5,
        }}
      >
        <Typography
          component="span"
          variant="body2"
          sx={{ fontWeight: 600, color: 'text.secondary' }}
        >
          {REQUESTS_LIST_COLUMNS_STRINGS.reviewType}
        </Typography>
        <IconButton
          size="small"
          onClick={e => setAnchorEl(e.currentTarget)}
          aria-label={REQUESTS_LIST_COLUMNS_STRINGS.reviewTypeFilterMenuAria}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          sx={{
            color: theme =>
              isFiltered ? theme.palette.primary.main : theme.palette.text.secondary,
          }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Box>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            onReviewTypeFilterChange(null)
            setAnchorEl(null)
          }}
          selected={!reviewTypeFilter}
        >
          {REQUESTS_LIST_COLUMNS_STRINGS.reviewTypeFilterAll}
        </MenuItem>
        <MenuItem
          onClick={() => {
            onReviewTypeFilterChange('approval')
            setAnchorEl(null)
          }}
          selected={reviewTypeFilter === 'approval'}
          sx={{ pl: 3 }}
        >
          {REQUESTS_LIST_COLUMNS_STRINGS.approval}
        </MenuItem>
        <MenuItem
          onClick={() => {
            onReviewTypeFilterChange('copyright')
            setAnchorEl(null)
          }}
          selected={reviewTypeFilter === 'copyright'}
          sx={{ pl: 3 }}
        >
          {REQUESTS_LIST_COLUMNS_STRINGS.copyright}
        </MenuItem>
      </Menu>
    </>
  )
}

export const reviewTypeFilterToListFilter = (
  reviewTypeFilter: TPublisherRequestListReviewTypeFilter,
) => {
  if (!reviewTypeFilter) return []

  if (reviewTypeFilter === 'approval') {
    return [
      {
        field: 'type',
        operator: 'eq' as const,
        value: PublisherRequestTypeEnum.APPROVAL_REQUEST,
      },
      {
        field: 'type',
        operator: 'eq' as const,
        value: PublisherRequestTypeEnum.LYRICS_APPROVAL_REQUEST,
      },
      {
        field: 'type',
        operator: 'eq' as const,
        value: PublisherRequestTypeEnum.COMMON_APPROVAL_REQUEST,
      },
    ]
  }

  return [
    {
      field: 'type',
      operator: 'eq' as const,
      value: PublisherRequestTypeEnum.COPYRIGHT_REQUEST,
    },
  ]
}
